<template>
  <modal name="withdraw" v-bind:width="400" v-bind:height="600"
         v-on:before-open="beforeOpen" v-on:before-close="beforeClose">
    <div class="withdrawWrapper">
      <div class="withdrawTop">
        <img v-bind:src="closeIcon" v-on:click="modalClose">
      </div>
      <div class="withdrawHeader">
        <span>회원탈퇴</span>
      </div>
      <div class="withdrawContentWrapper">
        <div class="withdrawItemNameDiv">
          <span class="itemName">현재 보유포인트</span>
        </div>
        <div class="withdrawNowAdPointDiv">
          <span>{{nowAdPoint == null ? 0 : nowAdPoint.toLocaleString() + '원'}}</span>
        </div>
        <div class="withdrawItemNameDiv">
          <span class="itemName">진행상황</span>
        </div>
        <div class="withdrawNowAdCountAndCouponCountDiv">
          <span class="text">진행중인 광고 </span>
          <span class="value">{{nowAdCount == null ? 0 : nowAdCount + '건'}}</span>
        </div>
        <div class="withdrawNowAdCountAndCouponCountDiv">
          <span class="text">기간이 남은 쿠폰 </span>
          <span class="value">{{nowCouponCount == null ? 0 : nowCouponCount + '개'}}</span>
        </div>
        <div class="withdrawItemNameDiv" v-bind:style="'margin-top:32px;'">
          <span class="itemName">주의상황</span>
        </div>
        <div class="withdrawCautionTextDiv">
          <span class="text">탈퇴를 하면 소비자 조사 및 광고가 즉시 중단되며,</span><br>
          <span class="emphasis">충전한 포인트는 환불되지 않습니다.</span><br>
          <span>이미 발행된 쿠폰은 회원 탈퇴 후에도 매장을 방문하는<br> 사용자들에게</span>
          <span class="emphasis">유효기간 중에는 혜택을 제공해야 합니다.</span>
        </div>
        <div class="withdrawConfirmDiv">
          <img v-bind:src="confirmCheckIcon" v-on:click="onCheckConfirm">
          <span>동의합니다.</span>
        </div>
      </div>
      <div class="withdrawFooter">
        <button class="withdrawBtn" v-bind:disabled="setDisable" v-on:click="onClickWithdrawBtn">탈퇴하기</button>
      </div>
    </div>
  </modal>
</template>

<script>
import store from '../../../store'

export default {
  data () {
    return {
      closeIcon: require('@/assets/img/modal_close_icon.png'),
      nowAdPoint: null,
      nowAdCount: null,
      nowCouponCount: null,
      confirmCheckIcon: null,
      isConfirmed: null
    }
  },
  methods: {
    beforeOpen: async function () {
      this.nowAdPoint = this.$store.getters.getAdUserStateValue('adPoint')
      let adCountData = await store.dispatch('adCountsApi', {searchText: null})
      this.nowAdCount = adCountData.data.data.onProgress
      let couponCountsData = await store.dispatch('getAdUserCouponCountsApi')
      this.nowCouponCount = couponCountsData.data.data.issuedAdCouponCount
      this.confirmCheckIcon = require('@/assets/img/checkbox_not_selected_img.png')
      this.isConfirmed = false
    },
    beforeClose: function () {
    },
    onCheckConfirm: function () {
      this.confirmCheckIcon = this.isConfirmed ? require('@/assets/img/checkbox_not_selected_img.png') : require('@/assets/img/checkbox_selected_img.png')
      this.isConfirmed = !this.isConfirmed
    },
    onClickWithdrawBtn: async function () {
      await store.dispatch('withdrawAdUser')
      this.modalClose()
      await this.$router.push({name: 'signIn'})
    },
    modalClose: function () {
      this.$modal.hide('withdraw')
    }
  },
  computed: {
    setDisable: function () {
      return !this.isConfirmed
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.withdrawWrapper {
  display : -webkit-flex;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
}

.withdrawTop {
  display : -webkit-flex;
  display: flex;
  justify-content: flex-end;
  height: 32px;
  padding-top: 12px;
  padding-right: 12px;
}

.withdrawTop > img {
  cursor: pointer;
  height: 100%;
  width: auto;
}

.withdrawHeader {
  display : -webkit-flex;
  display: flex;
  flex-direction: column;
  padding: 0 32px;
  font-size: 24px;
}

.withdrawContentWrapper {
  display : -webkit-flex;
  display: flex;
  flex-direction: column;
  height: 412px;
  padding: 0 32px;
}

.withdrawItemNameDiv{
  margin-top: 14px;
}

.itemName {
  font-size: 11px;
  color: rgb(0,153,255);
}

.withdrawNowAdPointDiv, .withdrawCautionTextDiv{
  margin: 16px 0;
}

.withdrawNowAdCountAndCouponCountDiv{
  margin-top: 16px;
}

.withdrawNowAdCountAndCouponCountDiv > .text {
  font-size: 13px;
}

.withdrawNowAdCountAndCouponCountDiv > .value {
  font-size: 15px;
  font-weight: bold;
}

.withdrawCautionTextDiv{
  font-size: 13px;
}

.withdrawCautionTextDiv > .emphasis{
  color: red;
  text-decoration: underline;
}

.withdrawNowAdPointDiv > span{
  font-size: 15px;
  font-weight: bold;
}

.withdrawConfirmDiv {
  display : -webkit-flex;
  display: flex;
  align-items: center;
}

.withdrawConfirmDiv > img {
  cursor: pointer;
  width: 32px;
  height: 32px;
}

.withdrawConfirmDiv > span {
  font-size: 13px;
  margin-left: 8px;
}

.withdrawFooter{
  display : -webkit-flex;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 103px;
}

.withdrawBtn{
  cursor: pointer;
  margin-left: 0;
  width: 196px;
  height: 50px;
  font-weight: bold;
  font-size: 15px;
  border: 2px solid rgb(0,153,255);
  border-radius: 0.3rem;
  color: white;
  outline: none;
  background-color: rgb(0,153,255);
}

.withdrawBtn:disabled{
  cursor: default;
  border: 2px solid rgb(207,207,207);
  border-radius: 0.3rem;
  color: white;
  outline: none;
  background-color: rgb(207,207,207);
}
</style>



// WEBPACK FOOTER //
// src/components/board/elements/withdrawModal.vue